import FieldFileInput from '@/components/UIComponents/FieldFileInput.vue';
import fgInput from './components/UIComponents/Inputs/formGroupInput.vue';
import UploadButton from './components/UIComponents/Inputs/UploadButton.vue';
import DropDown from './components/UIComponents/Dropdown.vue';
import AjaxTable from './components/UIComponents/AjaxTable.vue';
import Stats from './components/UIComponents/Stats.vue';
import EnyoSelect from './components/UIComponents/EnyoSelect.vue';

/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

const GlobalComponents = {
  install(Vue) {
    Vue.component('fg-input', fgInput);
    Vue.component('upload-button', UploadButton);
    Vue.component('drop-down', DropDown);
    Vue.component('AjaxTable', AjaxTable);
    Vue.component('stats', Stats);
    Vue.component('EnyoSelect', EnyoSelect);
    Vue.component('fieldFileInput', FieldFileInput);
  }
};

export default GlobalComponents;
